import Swal from 'sweetalert2';


type CustomClassType ={
        container?:string,
          popup?:string,
          header?:string,
          titleClass?:string,
          closeButton?: string,
          iconClass?: string,
          image?:string,
          content?:string,
          input?:string,
          actions?:string,
          confirmButton?:string,
          cancelButton?:string,
          footer?:string,
}

// type AlertType ={
//     icon?:string,
//     title?:string,
//     text?:string,
//     showCancelButton?:boolean,
//     showConfirmButton?:boolean,
//     confirmButtonText?:string,
//     cancelButtonText?:string,
//     timer?:number,
//     confirmButtonHandler?:any,
//     cancelButtonHandler?:any,

// }

export function fireAlert(alertArguments,customClassArguments:CustomClassType){
    let {toast,icon,title,text,showCancelButton,showConfirmButton,confirmButtonText,cancelButtonText,timer,confirmButtonHandler,cancelButtonHandler} = alertArguments;
    let {container,popup,titleClass,closeButton,iconClass,confirmButton,cancelButton,footer}=customClassArguments;
    Swal.fire({
        toast:toast,
        icon:  icon,
        title: title,
        text: text,
        showCancelButton: showCancelButton,
        showConfirmButton :showConfirmButton,
        confirmButtonText:confirmButtonText,
        cancelButtonText: cancelButtonText,
        timer:timer,
        reverseButtons :true,
        customClass:{
          container: container,
          popup: popup,
          title: titleClass,
          closeButton: closeButton,
          icon: iconClass,
          confirmButton: confirmButton,
          cancelButton: cancelButton,
          footer: footer,
        },
      })
      .then((response)=>{
        if(response.isDismissed && cancelButtonHandler) cancelButtonHandler();
        else if(response.isConfirmed && confirmButtonHandler) confirmButtonHandler();        
      })
      
      ;
}